module.exports = __webpack_public_path__ + "static/media/5.13.275f8a4f.png";